import { render } from "./TabelaDeHoras.vue?vue&type=template&id=105edce2&ts=true"
import script from "./TabelaDeHoras.vue?vue&type=script&lang=ts"
export * from "./TabelaDeHoras.vue?vue&type=script&lang=ts"

import "./TabelaDeHoras.vue?vue&type=style&index=0&id=105edce2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__